import React, { useState, useEffect, useContext } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { AuthContext } from "../../../contexts/AuthContext";
import { useStateContext } from "../../../contexts/ContextProvider";
import { Loader } from "../../../components";
import { FetchErrorHandling } from "../../../components/FetchErrorHandling";
import { postRequest } from "../../../constants/api";
import { handleLogout } from "../../../constants/logoutHelper";
import { validatePassword } from "../../../constants/validatePassword";
import { Container, Card, Form, Row, Col, ProgressBar } from "react-bootstrap";
import {
  Box,
  Button,
  Snackbar,
  Alert,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
  FormGroup,
  FormControlLabel,
  Checkbox,
  Typography,
  Autocomplete,
  TextField,
} from "@mui/material";
import EditIcon from "@mui/icons-material/Edit";
import useScreenWidth from "../../../hooks/useScreenWidth";

const UbahUser = () => {
  const [isFetchError, setIsFetchError] = useState(false);
  const screenSize = useScreenWidth();
  const { user, setting, dispatch } = useContext(AuthContext);
  const [open, setOpen] = useState(false);
  const [validated, setValidated] = useState(false);
  const [username, setUsername] = useState("");
  const [usernameLama, setUsernameLama] = useState("");
  const [tipeUser, setTipeUser] = useState("");
  const [password, setPassword] = useState("");
  const [kodeCabang, setKodeCabang] = useState("");
  const [cabangs, setCabangs] = useState([]);

  // Akses Master
  const [checkAllAkses, setCheckAllAkses] = useState(false);

  const [peserta, setPeserta] = useState(false);
  const [cabang, setCabang] = useState(false);

  // Akses Arisan
  const [kelompok, setKelompok] = useState(false);
  const [setoran, setSetoran] = useState(false);
  const [biaya, setBiaya] = useState(false);

  // Akses Lelang
  const [lelangBulanan, setLelangBulanan] = useState(false);
  const [bid, setBid] = useState(false);
  const [penetapanPemenang, setPenetapanPemenang] = useState(false);

  // Akses Laporan
  const [laporanPenerimaan, setLaporanPenerimaan] = useState(false);
  const [laporanBiaya, setLaporanBiaya] = useState(false);
  const [laporanPemenang, setLaporanPemenang] = useState(false);
  const [laporanKeuangan, setLaporanKeuangan] = useState(false);
  const [laporanTunggakan, setLaporanTunggakan] = useState(false);

  // Akses Utility
  const [profilUser, setProfilUser] = useState(false);
  const [daftarUser, setDaftarUser] = useState(false);
  const [settingAkses, setSettingAkses] = useState(false);

  const [error, setError] = useState(false);
  const navigate = useNavigate();
  const { id } = useParams();
  const [loading, setLoading] = useState(false);
  const [openAlert, setOpenAlert] = useState(false);

  const handleClickOpenAlert = () => {
    setOpenAlert(true);
  };

  const handleCloseAlert = () => {
    setOpenAlert(false);
  };

  const tipeUserOption = [
    {
      label: "MANAGER",
    },
    {
      label: "ADMIN",
    },
    {
      label: "PESERTA",
    },
  ];
  const tipeUserOptionOwner = [
    {
      label: "OWNER",
    },
    {
      label: "MANAGER",
    },
    {
      label: "ADMIN",
    },
    {
      label: "PESERTA",
    },
  ];
  const cabangOption = cabangs.map((cabang) => ({
    label: `${cabang.id} - ${cabang.namaCabang}`,
  }));

  const strengthLabels = [
    "Sangat Lemah",
    "Lemah",
    "Kurang Kuat",
    "Baik",
    "Kuat",
  ];
  const strengthColors = ["danger", "danger", "warning", "info", "success"];

  const handleClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setOpen(false);
  };

  useEffect(() => {
    getCabangsData();
    getUserById();
  }, []);

  const getCabangsData = async () => {
    const response = await postRequest(`/cabangs`, {}, navigate, dispatch);
    setCabangs(response.data);
  };

  const getUserById = async () => {
    setLoading(true);
    const response = await postRequest(
      `/findUser/${id}`,
      {},
      navigate,
      dispatch,
    );
    setUsername(response.data.username);
    setUsernameLama(response.data.username);
    setTipeUser(response.data.tipeUser);
    setKodeCabang(
      `${response.data.cabang.id} - ${response.data.cabang.namaCabang}`,
    );

    // Akses Master
    setPeserta(response.data.akses.peserta);
    setCabang(response.data.akses.cabang);

    // Akses Arisan
    setKelompok(response.data.akses.kelompok);
    setSetoran(response.data.akses.setoran);
    setBiaya(response.data.akses.biaya);

    // Akses Lelang
    setLelangBulanan(response.data.akses.lelangBulanan);
    setBid(response.data.akses.bid);
    setPenetapanPemenang(response.data.akses.penetapanPemenang);

    // Akses Laporan
    setLaporanPenerimaan(response.data.akses.laporanPenerimaan);
    setLaporanBiaya(response.data.akses.laporanBiaya);
    setLaporanPemenang(response.data.akses.laporanPemenang);
    setLaporanKeuangan(response.data.akses.laporanKeuangan);
    setLaporanTunggakan(response.data.akses.laporanTunggakan);

    // Akses Utility
    setProfilUser(response.data.akses.profilUser);
    setDaftarUser(response.data.akses.daftarUser);
    setSettingAkses(response.data.akses.setting);

    setLoading(false);
  };

  const updateUser = async (e) => {
    e.preventDefault();
    e.stopPropagation();
    const form = e.currentTarget;

    let isFailedValidation =
      form.checkValidity() || tipeUser.length != 0 || kodeCabang.length != 0;

    if (isFailedValidation) {
      if (password.length !== 0) {
        if (!validatePassword(password)["validation"]) {
          alert("Password tidak cukup kuat!");
          return;
        }
      }

      setLoading(true);
      const tempUsername = await postRequest(
        `/getUsername`,
        { username },
        navigate,
        dispatch,
      );
      let isUsernameNotValid =
        tempUsername.data.length > 0 && username !== usernameLama;
      if (isUsernameNotValid) {
        handleClickOpenAlert();
      } else {
        setLoading(true);

        await postRequest(
          `/users/${id}`,
          {
            username,
            tipeUser,
            password,
            akses: {
              peserta,
              cabang,

              kelompok,
              setoran,
              biaya,

              lelangBulanan,
              bid,
              penetapanPemenang,

              laporanPenerimaan,
              laporanBiaya,
              laporanPemenang,
              laporanKeuangan,
              laporanTunggakan,

              profilUser,
              daftarUser,
              setting: settingAkses,
            },
            cabangId: kodeCabang.split(" -", 1)[0],
          },
          navigate,
          dispatch,
        );
        setLoading(false);

        if (user.id == id) {
          handleLogout(dispatch, navigate);
        } else {
          navigate("/daftarUser");
        }
      }
      setLoading(false);
    } else {
      setError(true);
      setOpen(!open);
    }
    setValidated(true);
  };

  const textRight = {
    textAlign: screenSize >= 650 && "right",
  };

  const textRightSmall = {
    textAlign: screenSize >= 650 && "right",
    fontSize: "14px",
  };

  if (loading) {
    return <Loader />;
  }

  if (isFetchError) {
    return <FetchErrorHandling />;
  }

  return (
    <Container>
      <h3>Utility</h3>
      <h5 style={{ fontWeight: 400 }}>Ubah User</h5>
      <Dialog
        open={openAlert}
        onClose={handleCloseAlert}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">{`Data Username Sama`}</DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-slide-description">
            {`Username ${username} sudah ada, ganti Username!`}
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleCloseAlert}>Ok</Button>
        </DialogActions>
      </Dialog>
      <hr />
      <Card>
        <Card.Header>User</Card.Header>
        <Card.Body>
          <Form noValidate validated={validated} onSubmit={updateUser}>
            <Row>
              <Col sm={6}>
                <Form.Group
                  as={Row}
                  className="mb-3"
                  controlId="formPlaintextPassword"
                >
                  <Form.Label column sm="3" style={textRight}>
                    Username :
                  </Form.Label>
                  <Col sm="9">
                    <Form.Control
                      required
                      value={username}
                      onChange={(e) => setUsername(e.target.value)}
                      style={{ textTransform: "uppercase" }}
                    />
                  </Col>
                </Form.Group>
              </Col>
            </Row>
            <Row>
              <Col sm={6}>
                <Form.Group
                  as={Row}
                  className="mb-3"
                  controlId="formPlaintextPassword"
                >
                  <Form.Label column sm="3" style={textRight}>
                    Tipe User :
                  </Form.Label>
                  <Col sm="9">
                    <Autocomplete
                      size="small"
                      disablePortal
                      id="combo-box-demo"
                      options={
                        user.tipeUser === "OWNER"
                          ? tipeUserOptionOwner
                          : tipeUserOption
                      }
                      value={tipeUser}
                      renderInput={(params) => (
                        <TextField
                          size="small"
                          error={error && tipeUser.length === 0 && true}
                          helperText={
                            error &&
                            tipeUser.length === 0 &&
                            "Tipe User harus diisi!"
                          }
                          {...params}
                        />
                      )}
                      onChange={(e, value) => {
                        if (value) {
                          setTipeUser(value.label);
                        } else {
                          setTipeUser("");
                        }
                      }}
                    />
                  </Col>
                </Form.Group>
              </Col>
            </Row>

            <Row>
              <Col sm={6}>
                <Form.Group
                  as={Row}
                  className="mb-3"
                  controlId="formPlaintextPassword"
                >
                  <Form.Label column sm="3" style={textRight}>
                    Password :
                  </Form.Label>
                  <Col sm="9">
                    <Form.Control
                      value={password}
                      onChange={(e) => setPassword(e.target.value)}
                      style={{ textTransform: "uppercase" }}
                      placeholder="Isi jika ingin mengganti Password!"
                    />

                    {/* Password Strength Meter */}
                    {password && (
                      <>
                        <ProgressBar
                          variant={
                            strengthColors[validatePassword(password)["score"]]
                          }
                          now={(validatePassword(password)["score"] + 1) * 20}
                          className="mt-2"
                        />
                        <small className="text-muted">
                          {strengthLabels[validatePassword(password)["score"]]}
                        </small>
                        <p>{[validatePassword(password)["feedback"]]}</p>
                      </>
                    )}
                  </Col>
                </Form.Group>
              </Col>
            </Row>
            <Row>
              <Col sm={6}>
                <Form.Group
                  as={Row}
                  className="mb-3"
                  controlId="formPlaintextPassword"
                >
                  <Form.Label column sm="3" style={textRight}>
                    Cabang :
                  </Form.Label>
                  <Col sm="9">
                    {user.tipeUser === "OWNER" ? (
                      <Autocomplete
                        size="small"
                        disablePortal
                        id="combo-box-demo"
                        options={cabangOption}
                        renderInput={(params) => (
                          <TextField
                            size="small"
                            error={error && kodeCabang.length === 0 && true}
                            helperText={
                              error &&
                              kodeCabang.length === 0 &&
                              "Cabang harus diisi!"
                            }
                            {...params}
                          />
                        )}
                        onChange={(e, value) => {
                          if (value) {
                            setKodeCabang(value.label);
                          } else {
                            setKodeCabang("");
                          }
                        }}
                        value={kodeCabang}
                      />
                    ) : (
                      <Form.Control
                        required
                        value={kodeCabang}
                        disabled
                        readOnly
                      />
                    )}
                  </Col>
                </Form.Group>
              </Col>
            </Row>
            <Container style={{ marginTop: 30 }}>
              <h4>Hak Akses User</h4>
              <Box sx={showDataContainerCheck}>
                <Row>
                  <Col>
                    <FormGroup>
                      <FormControlLabel
                        control={<Checkbox checked={checkAllAkses} />}
                        label="Pilih Semua"
                        onChange={() => {
                          setCheckAllAkses(!checkAllAkses);
                          // Akses Master
                          setPeserta(!checkAllAkses);
                          setCabang(!checkAllAkses);

                          // Akses Arisan
                          setKelompok(!checkAllAkses);
                          setSetoran(!checkAllAkses);
                          setBiaya(!checkAllAkses);

                          // Akses Lelang
                          setLelangBulanan(!checkAllAkses);
                          setBid(!checkAllAkses);
                          setPenetapanPemenang(!checkAllAkses);

                          // Akses Laporan
                          setLaporanPenerimaan(!checkAllAkses);
                          setLaporanBiaya(!checkAllAkses);
                          setLaporanPemenang(!checkAllAkses);
                          setLaporanKeuangan(!checkAllAkses);
                          setLaporanTunggakan(!checkAllAkses);

                          // Akses Utility
                          setProfilUser(!checkAllAkses);
                          setDaftarUser(!checkAllAkses);
                          setSettingAkses(!checkAllAkses);
                        }}
                      />
                    </FormGroup>
                  </Col>
                </Row>
              </Box>
              <Box sx={showDataContainerCheck}>
                <Row>
                  <Col>
                    <Typography variant="p" sx={[spacingTop]}>
                      Master
                    </Typography>
                    <Form>
                      <FormGroup>
                        <FormControlLabel
                          control={<Checkbox checked={peserta} />}
                          label="Peserta"
                          onChange={() => setPeserta(!peserta)}
                        />
                      </FormGroup>
                    </Form>
                    <Typography variant="p" sx={[spacingTop]}>
                      Arisan
                    </Typography>
                    <Form>
                      <FormGroup>
                        <FormControlLabel
                          control={<Checkbox checked={kelompok} />}
                          label="Kelompok"
                          onChange={() => setKelompok(!kelompok)}
                        />
                      </FormGroup>
                      <FormGroup>
                        <FormControlLabel
                          control={<Checkbox checked={setoran} />}
                          label="Setoran"
                          onChange={() => setSetoran(!setoran)}
                        />
                      </FormGroup>
                      <FormGroup>
                        <FormControlLabel
                          control={<Checkbox checked={biaya} />}
                          label="Biaya"
                          onChange={() => setBiaya(!biaya)}
                        />
                      </FormGroup>
                    </Form>
                    <Typography variant="p" sx={[spacingTop]}>
                      Lelang
                    </Typography>
                    <Form>
                      <FormGroup>
                        <FormControlLabel
                          control={<Checkbox checked={lelangBulanan} />}
                          label="Lelang Bulanan"
                          onChange={() => setLelangBulanan(!lelangBulanan)}
                        />
                      </FormGroup>
                      <FormGroup>
                        <FormControlLabel
                          control={<Checkbox checked={bid} />}
                          label="Bid"
                          onChange={() => setBid(!bid)}
                        />
                      </FormGroup>
                      <FormGroup>
                        <FormControlLabel
                          control={<Checkbox checked={penetapanPemenang} />}
                          label="Penetapan Pemenang"
                          onChange={() =>
                            setPenetapanPemenang(!penetapanPemenang)
                          }
                        />
                      </FormGroup>
                    </Form>
                  </Col>
                  <Col>
                    <Typography variant="p" sx={[spacingTop]}>
                      Laporan
                    </Typography>
                    <Form>
                      <FormGroup>
                        <FormControlLabel
                          control={<Checkbox checked={laporanPenerimaan} />}
                          label="Laporan Penerimaan"
                          onChange={() =>
                            setLaporanPenerimaan(!laporanPenerimaan)
                          }
                        />
                      </FormGroup>
                      <FormGroup>
                        <FormControlLabel
                          control={<Checkbox checked={laporanBiaya} />}
                          label="Laporan Biaya"
                          onChange={() => setLaporanBiaya(!laporanBiaya)}
                        />
                      </FormGroup>
                      <FormGroup>
                        <FormControlLabel
                          control={<Checkbox checked={laporanPemenang} />}
                          label="Laporan Pemenang Bid"
                          onChange={() => setLaporanPemenang(!laporanPemenang)}
                        />
                      </FormGroup>
                      <FormGroup>
                        <FormControlLabel
                          control={<Checkbox checked={laporanKeuangan} />}
                          label="Laporan Keuangan"
                          onChange={() => setLaporanKeuangan(!laporanKeuangan)}
                        />
                      </FormGroup>
                      <FormGroup>
                        <FormControlLabel
                          control={<Checkbox checked={laporanTunggakan} />}
                          label="Laporan Tunggakan"
                          onChange={() =>
                            setLaporanTunggakan(!laporanTunggakan)
                          }
                        />
                      </FormGroup>
                    </Form>
                    <Typography variant="p" sx={[spacingTop]}>
                      Utility
                    </Typography>
                    <Form>
                      <FormGroup>
                        <FormControlLabel
                          control={<Checkbox checked={profilUser} />}
                          label="Profil User"
                          onChange={() => setProfilUser(!profilUser)}
                        />
                      </FormGroup>
                      {tipeUser !== "ADMIN" && (
                        <>
                          <FormGroup>
                            <FormControlLabel
                              control={<Checkbox checked={daftarUser} />}
                              label="Daftar User"
                              onChange={() => setDaftarUser(!daftarUser)}
                            />
                          </FormGroup>
                          <FormGroup>
                            <FormControlLabel
                              control={<Checkbox checked={settingAkses} />}
                              label="Setting"
                              onChange={() => setSettingAkses(!settingAkses)}
                            />
                          </FormGroup>
                        </>
                      )}
                    </Form>
                  </Col>
                </Row>
              </Box>
            </Container>
            <Box sx={spacingTop}>
              <Button
                variant="outlined"
                color="secondary"
                onClick={() => navigate("/daftarUser")}
                sx={{ marginRight: 2 }}
              >
                {"< Kembali"}
              </Button>
              <Button
                variant="contained"
                startIcon={<EditIcon />}
                type="submit"
              >
                Edit
              </Button>
            </Box>
          </Form>
        </Card.Body>
      </Card>
      {error && (
        <Snackbar open={open} autoHideDuration={6000} onClose={handleClose}>
          <Alert onClose={handleClose} severity="error" sx={alertBox}>
            Data belum terisi semua!
          </Alert>
        </Snackbar>
      )}
    </Container>
  );
};

export default UbahUser;

const colorRed = {
  color: "red",
};

const showDataContainerCheck = {
  mt: 4,
  flexDirection: {
    xs: "column",
    sm: "row",
  },
};

const showDataContainer = {
  mt: 4,
  display: "flex",
  flexDirection: {
    xs: "column",
    sm: "row",
  },
};

const showDataWrapper = {
  display: "flex",
  flex: 1,
  flexDirection: "column",
  maxWidth: {
    md: "40vw",
  },
};

const spacingTop = {
  mt: 4,
};

const alertBox = {
  width: "100%",
};

const secondWrapper = {
  marginLeft: {
    sm: 4,
  },
  marginTop: {
    sm: 0,
    xs: 4,
  },
};

const checkboxTitle = {
  marginBottom: 0,
};

const secondCheckboxTitle = {
  marginTop: 15,
  marginBottom: 0,
};
